<template>
  <div id="nav">
    <router-link to="/">
      <img alt="Crusade Cloud" src="../assets/wide.png" id="logo" style="position: absolute; top:5px; left:5px; width: 128px; z-index:100">
    </router-link>
    <router-link v-if="loggedIn" :to="{ name: 'force.listing' }">Forces</router-link>
    <router-link v-if="loggedIn" :to="{ name: 'unit.listing' }">Units</router-link>
    <router-link to="/about">About</router-link>
    <router-link v-if="!loggedIn" to="/register">Register</router-link>
    <router-link v-if="!loggedIn" to="/login">Login</router-link>
    <a href v-if="loggedIn" @click="logout()">Logout</a>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  computed: {
    ...mapState(["profile"]),
    loggedIn() {
      return Object.keys(this.profile).length > 1;
    }
  },
  methods: {
    ...mapActions({ logout: 'logout' })
  },
};
</script>

<style lang="scss" scoped>
#nav {
  background-color: rgb(3, 3, 6);
  margin: 0;
  padding: 0.5em 1em;
  border-bottom: solid 1px #999;

  a:nth-child(2) {
    margin-left: 128px;
  }

  a {
    margin-right: 1em;
    text-decoration: none;
    color: #fff;
  }
}
</style>